export const DRAWMODE = {
  polygon: "draw_polygon",
  rectangle: "draw_assisted_rectangle",
  select: "direct_select",
  simple_select: 'simple_select',
  rotate: "drag_rotate",
};


export const PROPERTY_SOURCE = {
  HAND_DRAWN: "HAND_DRAWN",
  FILE: 'FILE'
}

// id of Feature inside geoJSON of uploaded file
export const UPLOADED_GEOJSON_FEATURE_ID = 'uploaded';

export const UNITS_DEFAULT = 6;

export const UNITS = {
  4: "Millimeters (mm)",
  5: "Centimeters (cm)",
  6: "Meters (m)",
  7: "Kilometers (km)",
  2: "Feet (ft)",
  1: "Inches (in)",
  3: "Miles (mi)",
};

export const UNITS_LIST = [
  {
    id: "4",
    value: "Millimeters (mm)",
  },
  {
    id: "5",
    value: "Centimeters (cm)",
  },
  {
    id: "6",
    value: "Meters (m)",
  },
  {
    id: "7",
    value: "Kilometers (km)",
  },
  {
    id: "2",
    value: "Feet (ft)",
  },
  {
    id: "1",
    value: "Inches (in)",
  },
  {
    id: "3",
    value: "Miles (mi)",
  },
];

export const UPLOAD_STEPS = [
  "Choose DXF file",
  "Select drawing units",
  "Pick centre on map",
  "Adjust on map",
];
